import React, { useMemo, useRef, useState } from 'react'
import moment from 'moment-timezone'
import { useTimeZone } from 'civic-champs-shared/auth/hooks'
import { EventExpansionPanelSummary } from 'Event/components/EventExpansionPanelSummary'
import { EventExpansionPanelDetails } from 'Event/components/EventExpansionPanelDetails'
import { EventExpansionPanel } from 'Event/components/EventExpansionPanel'
import { OpportunityResponseWithRecurrenceInfo } from 'Event/interfaces/interfaceCreateEditEvent'
import { useExpansionPanelSummaryStyle } from 'Event/hooks/useExpansionPanelSummaryStyle'
import { ActivityLog } from 'tracking/activity/components/ActivityLog'
import { Opportunity } from '../interfaces'

export const EventDrilldownActivities = ({
  event,
  scrollTop,
}: {
  event: OpportunityResponseWithRecurrenceInfo
  scrollTop: number
}) => {
  const [expanded, setExpanded] = useState(true)
  const summaryRef = useRef<HTMLDivElement>(null)
  const detailsRef = useRef<HTMLDivElement>(null)
  const timeZone = useTimeZone()

  const fixedDateRange = useMemo(() => {
    const startDate = moment(event.startsAt).tz(timeZone).startOf('day')
    return {
      startDate,
      endDate: startDate.clone().endOf('day'),
    }
  }, [event.startsAt, timeZone])

  const opportunity = useMemo(
    () =>
      ({
        id: event.opportunityId,
        name: event.name,
        startsAt: event.startsAt,
        endsAt: event.endsAt,
        timeshifts: event.timeshifts,
      } as Opportunity),
    [event],
  )

  const style = useExpansionPanelSummaryStyle({
    expanded,
    scrollTop,
    summaryRef,
    detailsRef,
  })

  return (
    <EventExpansionPanel onChange={(_, expanded) => setExpanded(expanded)}>
      <EventExpansionPanelSummary name="event-activities" style={style} ref={summaryRef}>
        <h1>Activity Log</h1>
      </EventExpansionPanelSummary>
      <EventExpansionPanelDetails ref={detailsRef}>
        <ActivityLog
          opportunity={opportunity}
          tableName="eventActivityLog"
          occurrenceId={event.occurrenceId}
          fixedDateRange={fixedDateRange}
          hideDateRange
        />
      </EventExpansionPanelDetails>
    </EventExpansionPanel>
  )
}
